import React from 'react';

interface IScreenshot {
    src: string;
}

const Screenshot: React.FC<IScreenshot> = ({ src }) => {
    return (
        <div className="mx-auto mb-6 max-w-1/2 xl:max-w-1/4">
            <img src={src} alt="" className="shadow-1 rounded-2" />
        </div>
    );
};

export default Screenshot;
